/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/sum.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'The sum of a numeric expression.',
  examples: [
    'FROM employees\n| STATS SUM(languages)',
    'FROM employees\n| STATS total_salary_changes = SUM(MV_MAX(salary_change))',
    'TS exp_histo_sample\n| WHERE instance == "instance-0"\n| STATS total = ROUND(SUM(responseTime), 2)',
    'TS histogram_timeseries_index\n| WHERE instance == "instance-0"\n| STATS total = ROUND(SUM(responseTime::tdigest), 2)',
  ],
  params: {
    number: '',
  },
};

export default docs;
